/** Sweatpants Component */
import e from"react";import a from"styled-components";import{system as i,padding as g}from"styled-system";function l(t,r){return r?`-${r[t]}`:`-${t}`}const y=a("div")`
  &:before {
    display: block;
    content: '';
    ${i({gutter:{property:"marginTop",scale:"space",transform:l}})}
  }
`,u=a.div`
  display: flex;
  flex-wrap: wrap;
  ${i({gutter:{property:"marginLeft",scale:"space",transform:l}})}
  ${i({align:{property:"justifyContent",defaultScale:{center:"center",left:"flex-start",right:"flex-end"}}})}
`,x=a.div`
  ${g}
`,o=e.forwardRef(function(t,r){const{children:p,id:c,align:f,space:n="1rem"}=t,s=e.Children.toArray(p);return e.createElement(y,{id:c,gutter:n,ref:r},e.createElement(u,{gutter:n,align:f},s.map((m,d)=>e.createElement(x,{key:d,pt:n,pl:n},m))))});o.displayName="Inline";export{o as Inline};
//# sourceMappingURL=index.esm.js.map
